import { Component, inject } from '@angular/core';
import { UserService } from '../user.service';
import { PageComponent, PageService, Page } from '@tytapp/common';

@Page('login')
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends PageComponent {
  private userService = inject(UserService);
  
  get pageComponentId() {
    return 'login';
  }

  init(reasonOrParams : string | Object = null) {
    this.userService.goToLogin('/settings/memberships');
  }
}
